  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
          <h4 style="text-align:center;"> <span> Pesquisa e Actualize os dados em Transitação</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">

      <v-col class="d-flex" cols="3" sm="3">
          <v-text-field
            v-model="pesquisa"
            label="Informe o número de matricula( ou Bilhete )"
          ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="4" sm="3" >

          <v-btn :disabled="pesquisa === ''" color="primary" @click="Pesquisar()"><v-icon>search</v-icon></v-btn>

      </v-col>
     <v-col class="d-flex" cols="4" sm="4" >

          <label style="color:red" v-if="!msg_pesquisa">Estudante não encontrado!</label>
        <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

      </v-col>
    <v-btn class="mx-2" fab dark color="indigo" @click="dialog = true">
              <v-icon dark>add</v-icon>
            </v-btn>

    </v-row>
    <v-row>
        <v-col class="d-flex" cols="4" sm="5">
            <v-progress-linear v-if="progresso"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>

    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>

  <v-col md="12">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
    <hr>

    <v-data-table
            :headers="headers"
            :items="this.estudante_dados"
          >
          <template v-slot:item.action="{ item }">
              <v-icon  color="primary" class="mr-2"   @click="callUpdateDialog(item)">edit</v-icon>
            </template>
       </v-data-table>

  </v-col>

</v-row>
  </v-card>

  </v-container>
<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">

      <v-card>
        <v-card-title>
          <span class="headline">Informe os dados</span>
     <span  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</span>

        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field label="Nome" required
                    v-model="nome"
                >

                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Número de Matricula"
                   persistent-hint
                  required
                  v-model="matricula"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="AnoLectivo" required
                  v-model="editedItem.anolectivo"
                >

                </v-text-field>
              </v-col>

            </v-row>
          </v-container>
         </v-card-text>
        <v-card-actions>
          <v-row>
                   <v-col md="10"></v-col>
                   <v-col md="2">
                      <v-progress-circular v-if="progresso_2"
                    :size="50"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
                   </v-col>
                </v-row>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="Salvar_Transitacao()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

 <!-- Formulario de Actualização de Dados -->
  <template>
  <v-row justify="center">
    <v-dialog v-model="dialog_update" persistent max-width="800px">

      <v-card>
        <v-card-title>
          <span class="headline">Informe os dados</span>
     <span  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</span>

        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field label="Nome" required
                    v-model="editedItem.nome"
                    :disabled="true"
                >

                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Número de Matricula"
                   persistent-hint
                   :disabled="true"
                  required
                  v-model="editedItem.idMAtricula"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="AnoLectivo" required
                  :disabled="true"
                  v-model="editedItem.anolectivo"
                >

                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="ControloUltimoAnoParaProximo" required
                  v-model="editedItem.ControloUltimoParaOproximoAno"
                >

                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="Resultados"
                  v-model="editedItem.resultado"
                   item-text="descricao"
                   label="Resultado"
                ></v-select>
               </v-col>
                <v-col cols="6">

                <v-select
                 :items="Classes"
                  v-model="editedItem.anoacademico"
                  item-text="descricao"
                  item-value="id"
                  label="Classe existente"
              ></v-select>

              </v-col>

            </v-row>
          </v-container>
         </v-card-text>
        <v-card-actions>
          <v-row>
                   <v-col md="10"></v-col>
                   <v-col md="2">
                      <v-progress-circular v-if="progresso_3"
                    :size="50"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
                   </v-col>
                </v-row>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_update = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="Salvar_Actualizacao()">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({

    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    dialog_update: false,
    idMatricula: null,
    msg_pesquisa: true,
    pesquisa: '',
    estudante: true,
    dialog: false,
    progresso_2: false,
    progresso_3: false,
    progresso: false,
    pessoa: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    nome: '',
    matricula: '',
    anolectivo: '',
    Resultados:
    [
      { descricao: 'Não Transita' },
      { descricao: 'Transita' }
    ],
    Classes:
    [
      { id: 1, descricao: '10ª Classe' },
      { id: 2, descricao: '11ª Classe' },
      { id: 3, descricao: '12ª Classe' },
      { id: 4, descricao: '13ª Classe' }
    ],
    headers: [
      { text: 'Nome do Estudante', value: 'nome' },
      { text: 'Bilhete / Documento', value: 'bi' },
      { text: 'Ano Lectivo', value: 'anolectivo' },
      { text: 'Classe', value: 'classe' },
      { text: 'Resultado', value: 'resultado' },
      { text: 'ControloUltimoAnoParaProximo', value: 'ControloUltimoParaOproximoAno' },
      { text: 'Instituicao', value: 'descricao' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ],

    editedItem: {
      ControloUltimoParaOproximoAno: '',
      ResidenteEm: '',
      anoacademico: '',
      anolectivo: '',
      auto_data: '',
      autor: null,
      bi: '',
      certificado: null,
      data_: '',
      data_2: '',
      dataemissaobi: '',
      datanascimento: '',
      descricao: '',
      email: '',
      emitirCertificado: '',
      emitirCertificadoAutor: null,
      emitirCertificadoData: null,
      emitirCertificadoValidacaoStep: '',
      enable: '',
      fkPessoa: '',
      flag_dados_preparados: null,
      foto: null,
      idCurso: 0,
      idInstituicao: 0,
      idMAtricula: '',
      idMatricula: '',
      idMunicipio: 0,
      idPEssoa: '',
      idPerfil: '',
      instituicao: '',
      instituicaodescricao: '',
      morada: '',
      nome: '',
      nomedamae: '',
      nomedopai: '',
      pessoa: '',
      pkPessoa: '',
      resultado: '',
      sexo: '',
      sigla: '',
      classe: '',
      status_2: '',
      telefone: '',
      trasferidoIN: ''
    },
    editedIndex: -1

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select

  },
  methods: {

    async  Pesquisar () {
      try {
        this.progresso = true
        this.estudante_dados = await axios
          .get('/PesquisaTransitacao/' + this.pesquisa)
          .then(res => res.data)
        this.progresso = false

        if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
      } catch (error) {
        this.progresso = false
      }
    },

    async Salvar_Transitacao () {
      this.progresso_2 = true

      this.ObterPessoa()
      setTimeout(() => {
        if (this.pessoa.length) {
          let params =
             {
               matricula: this.matricula.trim(),
               nome: this.nome,
               anolectivo: this.editedItem.anolectivo,
               fkPessoa: this.pessoa[0].pkPessoa,
               flagActualizar: 0,
               controloAno: this.editedItem.ControloUltimoParaOproximoAno,
               resultado: this.editedItem.resultado
             }

          this.InserteOrUpdateTransitacao(params)
          this.progresso_2 = false
        } else {
          this.text = 'Este estudante não foi cadastrado'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })

          this.progresso_2 = false
        }
      }, 1000)
    },

    async  show_dialogo_transitacao () {
      this.dialog = true
    },

    async  ObterPessoa () {
      try {
        this.pessoa = await axios
          .get('/ObterPessoa/' + this.matricula)
          .then(res => res.data)
      } catch (error) {
        this.progresso = false
      }
    },

    async  InserteOrUpdateTransitacao (params) {
      try {
        let corMensagem = 'msgError'
        let msg = await axios
          .post('/TransitacaoInsertOrUpdate', params)
          .then(res => res.data)
        if (msg.length) {
          corMensagem = 'msgError'
          this.text = 'Ocorreu um erro ao tentar inserir o estudante'
        } else {
          corMensagem = 'msgSucess'
          this.text = 'Registro inserido com sucesso'
          this.dialog = false
          this.Limpar()
        }
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 8000 })
        this.progresso_2 = false
      } catch (error) {
        this.progresso_2 = false
      }
    },

    async Salvar_Actualizacao () {
      this.progresso_3 = true

      let params = {
        anolectivo: this.editedItem.anolectivo,
        matricula: this.editedItem.idMAtricula,
        nome: this.editedItem.nome,
        fkPessoa: this.editedItem.pkPessoa,
        controloAno: this.editedItem.ControloUltimoParaOproximoAno,
        flagActualizar: 1,
        resultado: this.editedItem.resultado,
        anoacademico: this.editedItem.anoacademico
      }

      try {
        let corMensagem = 'msgError'
        let msg = await axios
          .post('/TransitacaoInsertOrUpdate', params)
          .then(res => res.data)
        if (msg.length) {
          corMensagem = 'msgError'
          this.text = 'Ocorreu um erro ao tentar inserir o estudante'
        } else {
          corMensagem = 'msgSucess'
          this.text = 'Registro Actualizado com sucesso'
          this.estudante_dados = []
          this.dialog_update = false
          this.Limpar()
        }
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 8000 })
        this.progresso_3 = false
      } catch (error) {
        this.progresso_3 = false
      }
      this.progresso_3 = false
    },

    callUpdateDialog (item) {
       
      this.editedItem = Object.assign({}, item)
      console.log();
      this.dialog_update = true
    },

    Limpar () {
      // eslint-disable-next-line no-unused-expressions
      this.nome = ''
      this.anolectivo = ''
      this.matricula = ''
    }
  }

}

</script>
